import heroContentV1 from "./sections/V1/HeroSection/content.json";
import cvpContentV1 from "./sections/V1/ParagraphSection/CVPContent.json";
import switchContentV1 from "./sections/V1/ParagraphSection/SwitchContent.json";
import registerContentV1 from "./sections/V1/RegisterSection/content.json";
import heroContentV2 from "./sections/V2/HeroSection/content.json";
import cvpContentV2 from "./sections/V2/ParagraphSection/CVPContent.json";
import switchContentV2 from "./sections/V2/ParagraphSection/SwitchContent.json";
import registerContentV2 from "./sections/V2/RegisterSection/content.json";
import { Version } from "./types";

type ContentVersion1Type = [
  typeof heroContentV1,
  typeof cvpContentV1,
  typeof switchContentV1,
  typeof registerContentV1
];

type ContentVersion2Type = [
  typeof heroContentV2,
  typeof cvpContentV2,
  typeof switchContentV2,
  typeof registerContentV2
];

export const getContent = <T extends Version>(
  version: T
): ContentVersion1Type | ContentVersion2Type => {
  if (version === Version.V2) {
    return [heroContentV2, cvpContentV2, switchContentV2, registerContentV2];
  } else {
    return [heroContentV1, cvpContentV1, switchContentV1, registerContentV1];
  }
};
